'use client';

import { useMediaQuery } from '@tuic/lib/hooks/use-media-query';
export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)');
}